import React, { useState } from 'react';
import FormField from '../common/FormField';
import { VERIFICATION_STATUSES } from '../../utils/constants';
import { validateRequired } from '../../utils/validators';
import useForm from '../../hooks/useForm';
import { FiAlertCircle } from 'react-icons/fi';
import './ManualReview.css';

const ManualReview = ({ task, onCancel, onComplete }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = (vals) => {
    const errs = {};
    errs.status = validateRequired(vals.status, 'Status');
    errs.notes = validateRequired(vals.notes, 'Review Notes');
    if (vals.notes && vals.notes.length < 20) {
      errs.notes = 'Notes must be at least 20 characters explaining the decision.';
    }
    return errs;
  };

  const { values, errors, handleChange, handleSubmit } = useForm({
    status: '',
    notes: '',
    evidenceRef: ''
  }, validate);

  const onSubmit = (vals) => {
    setIsSubmitting(true);
    // Mock save
    setTimeout(() => {
      setIsSubmitting(false);
      onComplete();
    }, 1000);
  };

  const validStatuses = [
    { value: VERIFICATION_STATUSES.VERIFIED, label: 'Verified (Passed)' },
    { value: VERIFICATION_STATUSES.ATTENTION_REQUIRED, label: 'Attention Required (Flag)' },
    { value: VERIFICATION_STATUSES.INCONCLUSIVE, label: 'Inconclusive (Cannot verify)' },
    { value: VERIFICATION_STATUSES.UNAVAILABLE, label: 'Unavailable (Provider error)' }
  ];

  return (
    <div className="manual-review card">
      <div className="card-header bg-warning">
        <h2>Manual Review & Decision</h2>
      </div>
      <div className="card-body">
        <div className="review-context">
          <FiAlertCircle className="icon-warning" />
          <p><strong>Required:</strong> All adverse decisions or manual verifications require written justification. This result will be included in the applicant's final report.</p>
        </div>

        <form onSubmit={handleSubmit} className="review-form">
          <FormField 
            label="Verification Result" 
            name="status" 
            type="select" 
            options={validStatuses} 
            value={values.status} 
            onChange={handleChange} 
            error={errors.status}
            required 
          />
          
          <FormField 
            label="Reviewer Notes (min 20 characters)" 
            name="notes" 
            type="textarea" 
            value={values.notes} 
            onChange={handleChange} 
            error={errors.notes}
            placeholder="Explain the reasoning for this decision. What discrepancies were found? What manual checks were performed?"
            required 
          />
          
          <FormField 
            label="Supporting Evidence Reference (Optional)" 
            name="evidenceRef" 
            value={values.evidenceRef} 
            onChange={handleChange} 
            placeholder="e.g. Verified via phone call to employer on 10/25 at 14:00" 
          />

          <div className="review-actions">
            <button type="button" className="btn-secondary" onClick={onCancel} disabled={isSubmitting}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Saving...' : 'Finalize Decision'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManualReview;
